module.exports = __webpack_public_path__ + "img/engine_diagnostics.848a8311.png";